function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { List, Skeleton, Card, Tag, Input } from "antd";
import Common from "./includes/Common";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var Meta = Card.Meta;

var ConsumablesGrid = function ConsumablesGrid(_ref) {
  var selectHandler = _ref.selectHandler;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      pList = _useState2[0],
      setPList = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isDataLoading = _useState4[0],
      setIsDataLoading = _useState4[1];

  var _useState5 = useState("TOUS"),
      _useState6 = _slicedToArray(_useState5, 2),
      svalue = _useState6[0],
      setSvalue = _useState6[1];

  var _useState7 = useState('0'),
      _useState8 = _slicedToArray(_useState7, 2),
      searchWord = _useState8[0],
      setSearchWord = _useState8[1];

  var handleSegmentChange = function handleSegmentChange(v) {
    setSvalue(v.toString());
  };

  var onSearch = function onSearch(v) {
    if (v.target.value.length > 0) {
      setSearchWord(v.target.value);
    }
  };

  useEffect(function () {
    console.log(searchWord.toString());
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getconsumables/" + Common.currentUser.id + "/" + svalue + "/" + searchWord.toString()).then(function (response) {
      setPList([]);

      if (response.data.status == 200) {
        response.data.products.forEach(function (element) {
          setPList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              id: element.id,
              label: element.label,
              cost_price: element.cost_price,
              available_quantity: element.available_quantity,
              minimal_stock: element.minimal_stock
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [searchWord, svalue]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Input, {
      placeholder: "Nom de l'article",
      size: "large",
      onChange: onSearch,
      style: {
        width: '100%',
        marginBottom: '20px'
      }
    }), /*#__PURE__*/_jsx("br", {}), isDataLoading ? /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }) : /*#__PURE__*/_jsx(List, {
      grid: {
        gutter: 16,
        column: 3
      },
      dataSource: pList,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsx(List.Item, {
          onClick: function onClick() {
            selectHandler(item);
          },
          children: /*#__PURE__*/_jsx(Card, {
            style: {
              cursor: "pointer"
            },
            children: /*#__PURE__*/_jsx(Meta, {
              title: /*#__PURE__*/_jsx("b", {
                children: item.label
              }),
              description: /*#__PURE__*/_jsx(Tag, {
                color: "#f50"
              })
            })
          })
        });
      }
    })]
  });
};

export default ConsumablesGrid;